export default __webpack_public_path__ + "static/media/investmentBankingImg.26e99b4d.png";